<div class="layout-column full-height" appBringozIdGenerator="threepl-edit-voucher-view">
  <div class="layout-row padding-10 threepl-edit-voucher-header">
    <div class="layout-column layout-align-center-center margin-right-10">
      <bz-button variant="tertiary"
                 appBringozIdGenerator="threepl-edit-voucher-back-button"
                 [ariaLabel]="'Back' | translate"
                 (clicked)="back.emit()">
        <bz-icon [icon]="icons.back" size="xl"></bz-icon>
      </bz-button>
    </div>

    <div class="layout-column flex">
      <div class="layout-row layout-align-start-center">
        <span class="br-head-4 margin-right-10">{{ 'Voucher' | translate }}</span>
        <bz-tag [tone]="voucher().status | threeplStatusTone">{{ voucher().status | translate }}</bz-tag>
        <bz-button variant="tertiary"
                   appBringozIdGenerator="threepl-edit-voucher-print-button"
                   [ariaLabel]="'Print' | translate"
                   (clicked)="onPrintVoucher()">
          <bz-icon [icon]="icons.print"></bz-icon>
        </bz-button>
      </div>

      <div class="layout-row layout-align-start-center gap-5">
        <span class="br-head-3 font-weight-400">{{ voucher().threePlExtraData.name || voucher().externalId || voucher().id }}</span>
        @if (voucher().externalId) {
          <bz-icon [icon]="icons.hash"></bz-icon>
        }
        <span class="br-body-2">{{ voucher().externalId }}</span>
      </div>
    </div>

    <div class="layout-row layout-align-start-center gap-20">
      @if (voucher().threePlExtraData.name) {
        <div class="layout-column">
          <span class="br-body-2">{{ 'Name' | translate }}</span>
          <span class="br-body-2 font-weight-600">{{ voucher().threePlExtraData.name }}</span>
        </div>
      }
      <div class="layout-column">
        <span class="br-body-2">{{ 'Pickup Station' | translate }}</span>
        <span class="br-body-2 font-weight-600">{{ voucher().threePlExtraData.pickupTrainStation?.stationId }} {{ voucher().threePlExtraData.pickupTrainStation?.stationDescription }}</span>
      </div>
      <div class="layout-column">
        <span class="br-body-2">{{ 'Destination Station' | translate }}</span>
        <span class="br-body-2 font-weight-600">{{ voucher().threePlExtraData.destinationTrainStation?.stationId }} {{ voucher().threePlExtraData.destinationTrainStation?.stationDescription }}</span>
      </div>
    </div>
  </div>

  <app-threepl-train-voucher-containers-table class="flex"
                                              [containers]="containers()"
                                              [cars]="trainCars()"
                                              [sharedCarsMap]="sharedCarsMap()"
                                              [hazardousMaterials]="hazardousMaterials()"
                                              [isEdit]="true"
                                              (changeContainer)="onChangeContainer($event)"
                                              (isSharedCarChange)="onIsSharedCarChange($event)"
                                              (removeContainer)="onRemoveContainer($event)">
  </app-threepl-train-voucher-containers-table>

  <bz-divider></bz-divider>

  <div class="layout-row layout-align-start-center padding-5">
    <bz-button variant="tertiary"
               appBringozIdGenerator="threepl-edit-voucher-cancel-button"
               (clicked)="back.emit()">
      {{ 'Cancel' | translate }}
    </bz-button>
    <span class="flex"></span>
    <span class="br-body-2 margin-right-20">{{ 'Train Cars' | translate }}: {{ totalCars() }}</span>
    <span class="br-body-2">{{ 'Containers' | translate }}: {{ containers().length }}</span>
  </div>
</div>
